import currenciesActionTypes from '../actionTypes/currencies.ActionTypes';

const initialStore = {
  currenciesList: [],
  mainCurrencyList: [],
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case currenciesActionTypes.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        currenciesList: payload,
      };
    case currenciesActionTypes.REMOVE_CURRENCIES:
      return {
        ...state,
        currenciesList: [],
      };
    case currenciesActionTypes.GET_MAIN_CURRENCY_SUCCESS:
      return {
        ...state,
        mainCurrencyList: payload,
      };
    default:
      return state;
  }
};

export default reducer;
